import API from "./api";
import type { CreerCommentaireDto } from "@/types/commentaire.types";

const CommentaireService = {
  getByArticle: async (articleId: number) => {
    const response = await API.get("/commentaires", { params: { articleId } });
    return response.data.donnees;
  },

  getAllByArticle: async (articleId: number) => {
    const response = await API.get("/commentaires/admin", { params: { articleId } });
    return response.data.donnees;
  },

  create: async (payload: CreerCommentaireDto) => {
    const response = await API.post("/commentaires", payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/commentaires/${id}`);
    return response.data.donnees;
  },

  changerStatut: async (id: number, statut: "EN_ATTENTE" | "APPROUVE" | "REJETE") => {
    const response = await API.patch(`/commentaires/${id}/statut`, null, { params: { statut } });
    return response.data.donnees;
  },
};

export default CommentaireService;
